<template>
    <div>


        <v-form ref="form"
                v-model="valid"
                lazy-validation>
            <v-container fluid class="container-edit">
                <v-row>
                    <v-col cols="12" md="3">
                        <v-text-field v-model="dataItem.idLink" label="ID" disabled></v-text-field>
                    </v-col>

                    <v-col cols="12" md="3">
                        <v-select v-model="dataItem.idEstado" item-text="descripcion"
                                  item-value="id"
                                  :items="estados"
                                  label="Seleccione un estado"
                                  :rules="[v => !!v || 'Item is required']"
                                  required>
                        </v-select>
                    </v-col>

                    <v-col cols="12" md="3">
                        <v-text-field v-model="dataItem.descripcion"
                                      label="Descripcion"
                                      :rules="descripcionRules"
                                      required>
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" md="3">
                        <v-text-field v-model="dataItem.palabraClave"
                                      name="palabraClave"
                                      ref="palabraClave"
                                      label="Palabra Clave Única"
                                      :rules="palabraClaveRules"
                                      @change='onPalabraClaveChange($event, "palabraClave")'
                                      required></v-text-field>
                    </v-col>
                    <v-col cols="12" md="3">
                        <v-text-field v-model="dataItem.url"
                                      label="Dirección"
                                      :rules="urlRules"
                                      required>

                        </v-text-field>
                    </v-col>
                    <v-col cols="12" md="3">
                        <v-text-field v-model="dataItem.titulo"
                                      label="Título del libro"
                                      :rules="tituloRules"
                                      required></v-text-field>
                    </v-col>
                    <v-col cols="12" md="3">
                        <v-text-field v-model="dataItem.creador"
                                      label="Autor"
                                      readonly></v-text-field>
                    </v-col>
                    <v-col cols="12" md="3">
                        <v-select v-model="dataItem.idTipo"
                                  item-text="departamento"
                                  item-value="id"
                                  :items="tiposEditorial"
                                  label="Seleccione un tipo"
                                  :rules="[v => !!v || 'Item is required']"
                                  required>
                        </v-select>
                    </v-col>

                    <v-col cols="12" md="3">

                        <v-text-field v-model="dataItem.numVisitas"
                                      label="Visitas"
                                      readonly></v-text-field>
                    </v-col>
                </v-row>
                <v-row class="resultados-edit">
                    <v-col cols="12" md="6">
                        <a title="Enlace 1" :href="url1" target="_blank" class="link-text">
                            <img src="../../public/favicon.png" alt="Enlace 1" class="link" />
                            <span>Enlace editor 1</span>
                        </a>
                    </v-col>
                    <v-col cols="12" md="6">
                        <span>{{url1}}</span>
                    </v-col>
                </v-row>
                <v-row class="resultados-edit">
                    <v-col cols="12" md="6">
                        <a title="Enlace 2" :href="url2" target="_blank" class="link-text">
                            <img src="../../public/favicon.png" alt="Enlace 2" class="link" />
                            <span>Enlace editor 2</span>
                        </a>
                    </v-col>
                    <v-col cols="12" md="6">
                        <span>{{url2}}</span>
                    </v-col>
                </v-row>
                <v-row class="resultados-edit">
                    <v-col cols="12" md="6">
                        <a title="Enlace 3" :href="url3" target="_blank" class="link-text">
                            <img src="../../public/favicon.png" alt="Enlace 3" class="link" />
                            <span>Enlace editor 3</span>
                        </a>
                    </v-col>
                    <v-col cols="12" md="6">
                        <span>{{url3}}</span>
                    </v-col>
                </v-row>

                <v-row class="botonera-edit">
                    <v-col>
                        <v-btn color="primary right" :disabled="!valid" dark @click="submit()">GUARDAR</v-btn>
                        <v-btn color="primary right" dark @click="volver()">VOLVER</v-btn>

                    </v-col>
                </v-row>

            </v-container>
        </v-form>
        <v-dialog v-model="dialog"
                  max-width="400">
            <v-card>
                <v-card-title class="headline">Confirmar acción</v-card-title>

                <v-card-text>
                    Ya existe un enlace con la misma palabra clave. Solo el último enlace creado queda accesible.
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn color=""
                           text
                           @click="dialog = false">
                        Cancelar
                    </v-btn>

                    <v-btn color="blue"
                           text
                           @click="confirmSave">
                        Aceptar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
    import { mapState, mapGetters } from 'vuex';
    import HTTP from '../http-common';
    import { eventHub } from '../http-common/eventhub';
    export default {
        name: 'Nuevo',
        props: ['dataItem'],
        data() {
            return {
                valid: true,
                dialog: false,
                descripcionRules: [
                    v => !!v || 'Descripcion es obligatoria'
                ],
                palabraClaveRules: [
                    v => !!v || 'Palabra clave es obligatoria y única'
                ],
                urlRules: [
                    v => !!v || 'URL es obligatoria',
                    v => /^https?:\/\/?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/.test(v) || 'URL tiene que ser válida',
                ],
                tituloRules: [
                    v => !!v || 'Título es obligatoria'
                ],
            }
        },
        computed: {
            ...mapState(['estados']),
            ...mapGetters(['tiposEditorial']),
            url1() {
                let tipo = this.$_.findWhere(this.tiposEditorial, { idEditorial: this.dataItem.idEditorial, id: this.dataItem.idTipo });
                let idLink = this.dataItem.idLinkOld == null ? this.dataItem.idLink : this.dataItem.idLinkOld;
                
                return tipo.url == null || tipo.url == '' ? '-' : "https://" + tipo.url + "/enlace.asp?link=" + idLink;
            },
            url2() {
                let tipo = this.$_.findWhere(this.tiposEditorial, { idEditorial: this.dataItem.idEditorial, id: this.dataItem.idTipo });
               
                return tipo.url == null || tipo.url == '' ? '-' : "https://" + tipo.url + "/" + this.dataItem.palabraClave;
            },
            url3() {
                let tipo = this.$_.findWhere(this.tiposEditorial, { idEditorial: this.dataItem.idEditorial, id: this.dataItem.idTipo });
               
                return tipo.url2 == null || tipo.url2 == '' ? '-' : "https://" + tipo.url2 + "/" + this.dataItem.palabraClave;
            }
        },
        methods: {
            onPalabraClaveChange(value, field) {                                
                //let el =this.$refs[field]
            },
            submit() {
                if (this.$refs.form.validate()) {
                    HTTP.post('Enlace/check', this.dataItem)
                        .then((response) => {                          
                            if (response.data) {                                
                                HTTP.post('Enlace', this.dataItem)
                                    .then(() => {
                                        //this.$store.dispatch('refrescaEditoriales');
                                        this.$store.dispatch('establecerEnlaces');
                                        this.$snotify.success("Registro guardado correctamente", {
                                            position: "rightTop"
                                        });
                                    })
                                    .catch(e => {
                                        eventHub.$emit('error', e)
                                    });
                            }
                            else {                                
                                this.dialog = true;
                            }
                        })
                        .catch(e => {
                            eventHub.$emit('error', e)
                        });
                 
                    
                }

            },
            confirmSave() {
                this.dialog = false;              
                HTTP.post('Enlace', this.dataItem)
                    .then(() => {
                        //this.$store.dispatch('refrescaEditoriales');
                        this.$store.dispatch('establecerEnlaces');
                        this.$snotify.success("Registro guardado correctamente", {
                            position: "rightTop"
                        });
                    })
                    .catch(e => {
                        eventHub.$emit('error', e)
                    });
            },
            volver() {
                this.$router.push({ path: `/` })
            }
        },
    }
</script>

<style>
    .container-edit {
        background-color: #fff;
        padding: 30px;
        margin-top: 30px;
        border-radius: 5px;
    }
    .resultados-edit {
        color: #1876d2;
        text-align: left;
        background-color: #f1f1f1;
        border-bottom: 1px solid #dbdbdb;
    }
    .botonera-edit button {
        margin-left: 20px
    }
    .link
    {
        width: 15px;
        margin-right: 4px;
    }
    .link-text
    {
        text-decoration: none;
    }
</style>